import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'

// Get All Opening Balances
export const getOpeningBalancesReq = (action) => {
    const params = action?.data || {};
    return axiosInstance.get(apiEndpoints.GET_OPENING_BALANCES_API, { params })
}

// Get Opening Balance Details by ID
export const getOpeningBalanceDetailsReq = (action) => {
    const { id } = action?.data || {};
    const url = apiEndpoints.GET_OPENING_BALANCE_DETAILS_API.replace(':id', id);
    return axiosInstance.get(url)
}

// Create Opening Balance
export const createOpeningBalanceReq = (action) => {
    const payload = action?.data || {};
    const body = { ...payload };
    delete body.onSuccess;
    return axiosInstance.post(apiEndpoints.CREATE_OPENING_BALANCE_API, body)
}

// Update Opening Balance
export const updateOpeningBalanceReq = (action) => {
    const payload = action?.data || {};
    const { id } = payload;
    const url = apiEndpoints.UPDATE_OPENING_BALANCE_API.replace(':id', id);
    const body = { ...payload };
    delete body.id;
    delete body.onSuccess;
    return axiosInstance.put(url, body)
}

// Delete Opening Balance
export const deleteOpeningBalanceReq = (action) => {
    const { id } = action?.data || {};
    const url = apiEndpoints.DELETE_OPENING_BALANCE_API.replace(':id', id);
    return axiosInstance.delete(url)
}

// Bulk Upload Opening Balances
export const bulkUploadOpeningBalancesReq = (action) => {
    const { formData } = action?.data || {};
    return axiosInstance.post(apiEndpoints.BULK_UPLOAD_OPENING_BALANCES_API, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}
